<template>
  <div class="debate-box" :class="[
    adsHidden ? '' : `ad-position-${adPosition.replace('native', 'left').replace('_format_', '-')}`,
    widgetCssClass,
  ].join(' ')
    ">
    <MainAdBox :isSidePanel="isSidePanel" />

    <div class="debate-main">
      <div class="debate-main-holder" :class="{ 'is-blurred': showEmailModal }">
        <div class="share-button" @click="showMoreModal = true">
          <SvgElement name="circles-icon" />
        </div>

        <DebateMainInfo :debate="debate" :isSidePanel="isSidePanel" :isDebateFeed="isDebateFeed" />

        <div class="button-bar" v-if="
          !isSidePanel && (debate.votedSideId || debate.isClosed) && !isQuiz && embedPlacementData && embedPlacementData.hideCTA == 0
        ">
          <a v-if="showConversionButton" class="blue-button full-grow" :href="debate.affiliateLink" target="_blank">
            {{ debate.affiliateButtonText }}
          </a>
          <button v-else-if="!isPoll" class="blue-button full-grow"
            @click="handleButton(debate, false, debate.arguments ? 'See the discussion' : 'Add the first comment');">
            {{
              debate.arguments
                ? $t("See the discussion")
                : $t("Add the first comment")
            }}

          </button>
          <button v-else-if="isPoll" class="blue-button full-grow"
            @click="handleButton(debate, true, 'See more polls')">
            See more polls
          </button>
        </div>

        <div class="debate-history" v-if="debateHistory.length > 1 && !isDebateFeed">
          <span v-for="previousDebate in debateHistory" v-bind:key="previousDebate.id"
            v-bind:class="{ active: previousDebate.id === debate.id }" @click="changeDebate(previousDebate)"></span>
        </div>

        <div class="numbers-bar is-main" :class="{ 'has-separator': isSidePanel }">
          <div class="counts">
            <div class="votes-count">
              {{ debate.votes }}
              <template v-if="isQuiz">
                {{ debate.votes === 1 ? $t("response") : $t("responses") }}
              </template>
              <template v-else>
                {{ debate.votes === 1 ? $t("vote") : $t("votes") }}
              </template>
            </div>
            <span v-if="false && isQuiz && debate.votedSideId" class="correct-percent">
              &bull; {{ debate.correctPercent() }}% picked the correct answer
            </span>
            <template v-if="!isPoll && !isQuiz">
              <div class="count-separator">&bull;</div>
              <div class="comments-count text-button" @click="onShowSidePanel(debate)" v-if="!isSidePanel">
                {{ debate.arguments + debate.comments }}
                {{
                  debate.arguments + debate.comments === 1
                    ? $t("comment")
                    : $t("comments")
                }}
              </div>
              <div class="comments-count" v-if="isSidePanel && !(sidePanelTab === 'feed' && !feedDebate)">
                {{ debate.arguments + debate.comments }}
                {{
                  debate.arguments + debate.comments === 1
                    ? $t("comment")
                    : $t("comments")
                }}
              </div>
              <div class="comments-count text-button" @click="setFeedDebate(debate)"
                v-if="isSidePanel && sidePanelTab === 'feed' && !feedDebate">
                {{ debate.arguments + debate.comments }}
                {{
                  debate.arguments + debate.comments === 1
                    ? $t("comment")
                    : $t("comments")
                }}
              </div>
            </template>
          </div>

          <div @click="showMoreModal = true" v-if="isSidePanel" class="numbers-bar-share">
            <SvgElement name="circles-icon" />
          </div>

          <div v-if="!isSidePanel && false">
            <strong v-if="globals.userInfo" class="user-info-footer" @click="
              onShowSidePanel(debate);
            openProfile();
            ">
              <img v-if="globals.userInfo && globals.userInfo.avatarObject"
                :style="{ borderColor: globals.userInfo.statusColor }"
                :src="globals.userInfo.avatarObject.thumb.location" />
              <span>{{ globals.userInfo.username }}</span>
            </strong>

            <span class="text-button" v-if="userIsVerified && !globals.userInfo" @click="
              onShowSidePanel(debate);
            setSidePanelTab('complete-signup');
            ">
              {{ $t("Complete sign-up") }}
            </span>
          </div>

          <a href="https://business.sided.co" target="_blank" v-if="!isSidePanel">
            <img :src="require('../assets/logo.svg')" width="49" />
          </a>
        </div>

        <div v-if="isSidePanel && sidebarAds && allowAds" class="outbrain-holder">
          <div class="OUTBRAIN" :data-src="getPageUrl()" :data-external-id="getEmbedDomainId"
            :data-widget-id="isMobile() ? 'AR_40' : 'AR_30'"></div>
        </div>

        <div class="login-cta" v-if="
          !isPoll &&
          !globals.userInfo &&
          !isSidePanel &&
          debate.votedSideId &&
          arguments.length === 0
        ">
          <div class="login-cta-text">{{ $t("Leave the first comment") }}!</div>
          <div class="login-cta-btns">
            <span class="text-button underlined" @click="initLogin()">
              {{ $t("Login") }}
            </span>
            {{ $t("or") }}
            <span class="text-button underlined" @click="initSignup()">
              {{ $t("sign up") }}
            </span>
          </div>
        </div>

        <div class="comment-cta" v-if="
          !isPoll &&
          globals.userInfo &&
          !isSidePanel &&
          debate.votedSideId &&
          arguments.length === 0
        ">
          <div v-if="globals.userInfo" class="profile-photo">
            <figure :style="{ borderColor: globals.userInfo.statusColor }">
              <img v-if="globals.userInfo && globals.userInfo.avatarObject"
                :src="globals.userInfo.avatarObject.thumb.location" />
              <div v-for="role in globals.userInfo.roles" v-bind:key="role.name">
                <span v-if="role.name === 'VERIFIED'" class="checkmark"
                  :style="{ backgroundColor: globals.userInfo.checkmarkColor }">
                  <SvgElement name="check-icon" />
                </span>
              </div>
            </figure>
            <span class="logout-btn text-button" @click="onLogOut">
              {{ $t("Log out") }}
            </span>
          </div>
          <div>
            <div class="comment-cta-text">
              {{ $t("Hey") }} {{ globals.userInfo.username }}!
              <span class="text-button underlined" @click="showNextDebate()">{{
                $t("See next poll")
              }}</span>
            </div>
            <span class="comment-cta-btn text-button underlined" @click="onLeaveComment">
              {{ $t("Leave the first comment") }}
            </span>
          </div>
        </div>

        <ArgumentsFeed v-if="!isPoll && showTopComment && !isSidePanel" :debate="debate" :isTopComment="true"
          :isSidePanel="isSidePanel" :justFirstComment="!isSidePanel" />

        <div class="scrollable" v-if="isSidePanel && showAllComments">
          <ArgumentsFeed v-if="!isPoll" :debate="debate" :isTopComment="false" :isSidePanel="isSidePanel"
            :feedDebateArguments="feedDebateArguments" :isCustomArgumentsFeed="isCustomArgumentsFeed" />
        </div>
      </div>
    </div>

    <MoreModal v-if="showMoreModal" :debate="debate" @close="showMoreModal = false" />

    <div v-if="!isSidePanel && false" class="embed-footer" :class="{ 'is-blurred': showEmailModal }">
      <span v-if="globals.userInfo" class="user-info" @click="
        onShowSidePanel(debate);
      openProfile();
      ">
        <img v-if="globals.userInfo && globals.userInfo.avatarObject"
          :style="{ borderColor: globals.userInfo.statusColor }" :src="globals.userInfo.avatarObject.thumb.location" />
        <span>{{ globals.userInfo.username }}</span>
      </span>

      <span class="text-button" v-if="userIsVerified && !globals.userInfo" @click="
        onShowSidePanel(debate);
      setSidePanelTab('complete-signup');
      ">
        {{ $t("Complete sign-up to see all results") }}
      </span>

      <div v-if="!userIsVerified && !globals.userInfo">
        <span class="text-button" @click="initLogin()">{{ $t("Login") }}</span>
        | <span class="text-button" @click="initSignup()">Signup</span>
      </div>

      <a href="https://sided.co" target="_blank" class="footer-logo">
        <img :src="require('../assets/logo.svg')" class="logo" />
      </a>
    </div>
  </div>
</template>

<script>
import MainAdBox from "./MainAdBox";
import MoreModal from "./MoreModal";
import SvgElement from "./SvgElement";
import ArgumentsFeed from "./ArgumentsFeed";
import DebateMainInfo from "./DebateMainInfo";

export default {
  name: "DebateBox",
  data() {
    return {
      showMoreModal: false,
    };
  },
  props: {
    debate: {
      type: Object,
      default: null,
    },
    changeDebateHistory: {
      type: Function,
      default: () => {},
    },
    isSidePanel: {
      type: Boolean,
      default: false,
    },
    isDebateFeed: {
      type: Boolean,
      default: false,
    },
    showTopComment: {
      type: [Boolean, Number],
      default: false,
    },
    showAllComments: {
      type: Boolean,
      default: true,
    },
    feedDebateArguments: {
      type: Array,
      default: () => [],
    },
    isCustomArgumentsFeed: {
      type: Boolean,
      default: false,
    },
    showConversionButton: {
      type: Boolean,
      default: false,
    },
    allowAds: {
      type: Boolean,
      default: false,
    },
  },
  inject: [
    "isPoll",
    "isQuiz",
    "globals",
    "isMobile",
    "onLogOut",
    "adsHidden",
    "initLogin",
    "arguments",
    "getPageUrl",
    "sidebarAds",
    "changeDebateFromHistory",
    "initSignup",
    "adPosition",
    "feedDebate",
    "setGlobals",
    "openProfile",
    "debateClient",
    "requireEmail",
    "sidePanelTab",
    "debateHistory",
    "setFeedDebate",
    "showNextDebate",
    "showEmailModal",
    "userIsVerified",
    "widgetCssClass",
    "onShowSidePanel",
    "setSidePanelTab",
    "fireEvent",
    "embedPlacementData"
  ],
  components: {
    MainAdBox,
    MoreModal,
    SvgElement,
    ArgumentsFeed,
    DebateMainInfo,
  },
  computed: {
    getEmbedDomainId() {
      return window.sidedSessionData ? window.sidedSessionData.embedDomainId : 0;
    }
  },
  methods: {
    onLeaveComment() {
      this.onShowSidePanel(this.debate);
    },
    handleButton(debate, showFeed, buttonText) {
      this.onShowSidePanel(debate, showFeed);
      this.fireEvent({
        debateId: this.debate.id,
        ctaButtonCaption: buttonText,
        eventType: "cta_click",
      })
    },
    formatDate(date) {
      return new Date(date).toLocaleString("en-US", {
        month: "short",
        day: "numeric",
      });
    },
    changeDebate(previousDebate) {
      console.log("changeDebate", previousDebate, this.debateHistory, this.changeDebateFromHistory);
      this.changeDebateFromHistory(previousDebate);
    },
  },
};
</script>
